import { Component, OnInit, } from '@angular/core';
import {
  AbstractBlModal, ModalButtonType, BlModalService, ModalReason, BlDialogService
} from '@blcloud/bl-ng-ui-component';
import { IEmployee } from '@blcloud/bl-datamodel';
import { EmployeeGuideComponent, EmployeeResourceService } from '@blcloud/bl-ng-share-module';
import { DateTimeUtils, JapanEraType } from '@blcloud/bl-common';
import { Observable } from 'rxjs/Observable';
import { BlApiQueryParams, BlApiSearchCondition, BlApiConditionHelper, BlListResponseBody } from '@blcloud/bl-ng-common';
import { isEmpty as _isEmpty, isNil as _isNil } from 'lodash';
import { ContactUpdateInfo } from './edit-modal.interface';

/**
 * コンタクト一覧一括編集モーダル
 */
@Component({
  templateUrl: './edit-modal.component.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditModalComponent extends AbstractBlModal implements OnInit {

  modalButtonType: typeof ModalButtonType = ModalButtonType;

  /** 実施予定日変更区分 */
  changeContactScheduleDateDiv: boolean;
  /** 実施予定日時 */
  contactScheduleDate: string = DateTimeUtils.formatIso(DateTimeUtils.today());
  /** 時間(実施予定時間)変更区分 */
  changeContactScheduleTimeDiv: boolean;
  /** 時間(実施予定時間)選択値 */
  contactScheduleTime: string;
  /** 担当者(従業員コード)変更区分 */
  changeEmployeeCodeDiv: boolean;
  /** 担当者(従業員コード) */
  employeeCode: string;
  /** 担当者(従業員名称) */
  employeeName: string;

  /** 元号のタイプ */
  readonly JapanEraType = JapanEraType;

  constructor(
    private modalService: BlModalService,
    private employeeService: EmployeeResourceService,
    private dialogService: BlDialogService,
  ) {
    super();
  }

  ngOnInit() {
  }

  getResults() {
    const contactUpdateInfo: ContactUpdateInfo = {};
    if (this.changeContactScheduleDateDiv === true) {
      contactUpdateInfo.contactScheduleDate = this.contactScheduleDate;
    }
    if (this.changeContactScheduleTimeDiv === true) {
      contactUpdateInfo.contactScheduleTime = this.contactScheduleTime;
    }
    if (this.changeEmployeeCodeDiv === true) {
      contactUpdateInfo.employeeCode = this.employeeCode;
      contactUpdateInfo.employeeName = this.employeeName;
    }
    return contactUpdateInfo;
  }

  /**
   * モーダル終了イベント
   * @param reason　モーダル終了理由
   */
  dismiss(reason?: ModalReason) {
    if (reason === ModalReason.Done) {
      this.dialogService.confirm('コンタクト情報を変更します。よろしいですか？').subscribe(
        modalRef => {
          if (modalRef.reason === ModalReason.Done) {
            this.emitDismissEvent(reason);
          }
          modalRef.hide();
        }
      );
    } else {
      this.emitDismissEvent(reason);
    }
  }

  onShown() {
    // デフォルト値設定
    this.changeContactScheduleDateDiv = false;
    this.changeContactScheduleTimeDiv = false;
    this.changeEmployeeCodeDiv = false;
  }

  /**
   * 編集項目の値変更
   * @param propertyId　変更した項目
   * @param value　変更した入力値
   */
  onChangeProp(propertyId: string, value: any) {
    switch (propertyId) {
      case 'changeContactScheduleDateDiv':
        this.changeContactScheduleDateDiv = value.target.checked;
        break;
      case 'contactScheduleDate':
        this.contactScheduleDate = value;
        break;
      case 'changeContactScheduleTimeDiv':
        this.changeContactScheduleTimeDiv = value.target.checked;
        break;
      case 'contactScheduleTime':
        let time: string[];
        if (!_isNil(value)) {
          time = value.split(':', 2);
          this.contactScheduleTime = time[0] + time[1];
        }
        break;
      case 'changeEmployeeCodeDiv':
        this.changeEmployeeCodeDiv = value.target.checked;
        break;
      case 'employeeCode':
        this.searchEmployee(value).subscribe(
          emp => {
            if (!_isEmpty(emp)) {
              this.employeeCode = emp.employeeCode;
              this.employeeName = emp.employeeName;
            } else {
              this.employeeCode = '';
              this.employeeName = '';
            }
          }
        );
        break;
    }
  }

  /**
   * 従業員コードから従業員検索
   * @param code　従業員コード
   */
  searchEmployee(code: string): Observable<IEmployee> {
    const param = new BlApiQueryParams();
    const condition = new BlApiSearchCondition();
    condition.addCondition(BlApiConditionHelper.makeCondAnd(BlApiConditionHelper.makeCondStrEqual('employeeCode', code)));
    param.setCondition(condition);

    return this.employeeService.get({ params: param }).map(
      (result: BlListResponseBody<IEmployee>) => result ? result.searchResultList[0] : null);
  }

  /**
   * 担当者ガイドボタン押下
   * @param btnEl　フォーカスターゲット
   */
  onClickEmployeeGuide(btlEl) {
    this.modalService.show(EmployeeGuideComponent).pipe().subscribe(
      modalRef => {
        if (modalRef.reason === ModalReason.Done) {
          const result = <IEmployee>modalRef.getResults();
          if (result.employeeCode !== null) {
            this.employeeCode = result.employeeCode;
            this.employeeName = result.employeeName;
          }
        }
        modalRef.hide(btlEl);
      }
    );
  }

  /**
   * キャンセルボタン押下
   */
  onCancel() {
    this.dismiss(ModalReason.Cancel);
  }

  /**
   * 決定ボタン押下
   */
  onSuccess() {
    this.dismiss(ModalReason.Done);
  }
}



// WEBPACK FOOTER //
// ./src/app/page/contact-list-page/modal/edit-modal.component.ts